<media-image [options]="options" [apiUrl]="apiUrl" [gallery]="gallery" [image]="content" (onAdd)="add($event)" (onDelete)="delete()"></media-image>
